import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Kit después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un correo con el link de descarga de todos los archivos en formato PDF. El acceso es instantáneo, las 24 horas, los 7 días de la semana.'
}, {
  q: '¿Sirve si mi hijo fue diagnosticado hace poco?',
  a: 'Especialmente para vos. El Kit está diseñado para darte toda la base que el sistema de salud no tiene tiempo de explicarte, desde el principio y en lenguaje de mamá.'
}, {
  q: '¿Necesito conocimientos médicos previos?',
  a: 'No. Todo está explicado en lenguaje claro y directo. El objetivo es que puedas aplicar los protocolos sin depender de que alguien te explique cada vez.'
}, {
  q: '¿Los 3 bonos están incluidos en las dos opciones?',
  a: 'Sí. Los 3 bonos están incluidos tanto en el Kit base como en el Kit Completo sin costo adicional.'
}, {
  q: '¿Sirve si mi hijo ya tiene tratamiento médico con su neurólogo?',
  a: 'Absolutamente. El Kit no reemplaza al neurólogo, lo complementa. Te ayuda a ser una madre más informada, con mejores registros y mejores preguntas para cada consulta.'
}, {
  q: '¿Qué diferencia tiene con los grupos de Facebook o el Dr. Google?',
  a: 'Los grupos dan contención emocional pero no protocolos. Google da información desordenada y muchas veces contradictoria. Este Kit te da un sistema organizado, validado y adaptado a la realidad argentina.'
}, {
  q: '¿Funciona si vivo en el interior del país?',
  a: 'Sí. Todo el contenido está adaptado al sistema de salud argentino en general. La Ley de Epilepsia, los derechos de cobertura y los protocolos aplican en todo el territorio nacional.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no estás satisfecha, te devolvemos el 100% del pago sin preguntas.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 md:py-20 bg-white" data-id="element-77">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78">
        <div className="text-center mb-8 sm:mb-10 md:mb-12" data-id="element-79">
          <h2 className="text-sm font-bold text-brand-orange tracking-widest uppercase mb-2" data-id="element-80">
            DUDAS COMUNES
          </h2>
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900" data-id="element-81">
            PREGUNTAS FRECUENTES
          </h3>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-82">
          {faqs.map((faq, i) => <div key={i} className="border-b border-gray-200 pb-2" data-id="element-83">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full py-3 sm:py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-84">
                <span className="font-bold text-gray-900 pr-8 text-sm sm:text-base" data-id="element-85">
                  {faq.q}
                </span>
                <ChevronDown className={`text-brand-orange flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-86" />
              </button>
              <AnimatePresence data-id="element-87">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-88">
                    <p className="text-gray-600 pb-4 sm:pb-6 leading-relaxed text-sm sm:text-base" data-id="element-89">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};